import {Question} from "./course";

export type LastSubmission = {
    sealed: boolean;
    passed: boolean;
    startsAt: string;
    endsAt: string;
    questions: Question[];
};

export type Attestation = {
    id: string;
    name: string;
    lastSubmission: LastSubmission;
}


export const enum ATTESTATION_STATUS {
    NOT_FOUND = 'notFound',
    OUTDATED_FAILED = 'outdatedAndFailed',
    OUTDATED_PASSED = 'outdatedAndPassed',
    ACTUAL_FAILED = 'actualAndFailed',
    ACTUAL_PASSED = 'actualAndPassed',
    UPCPMMING = 'upcomming',
}

export const detectAttestationStatus = (attestation: Attestation): ATTESTATION_STATUS => {
    const {lastSubmission} = attestation;
    // notFound
    if (!lastSubmission) {
        return ATTESTATION_STATUS.NOT_FOUND;
    }

    // outdated
    if (lastSubmission.sealed) {
        return lastSubmission.passed
            ? ATTESTATION_STATUS.OUTDATED_PASSED
            : ATTESTATION_STATUS.OUTDATED_FAILED;
    }

    const startsDate = Date.parse(lastSubmission.startsAt);
    // actual
    if (startsDate < Date.now()) {
        return lastSubmission.passed
            ? ATTESTATION_STATUS.ACTUAL_PASSED
            : ATTESTATION_STATUS.ACTUAL_FAILED;
    }
    return ATTESTATION_STATUS.UPCPMMING;
}

export const isOutdated = (status: ATTESTATION_STATUS) =>
    (status === ATTESTATION_STATUS.OUTDATED_FAILED || status === ATTESTATION_STATUS.OUTDATED_PASSED);

export const isFailed = (status: ATTESTATION_STATUS) =>
    (status === ATTESTATION_STATUS.OUTDATED_FAILED || status == ATTESTATION_STATUS.ACTUAL_FAILED);

export const isPassed = (status: ATTESTATION_STATUS) =>
    (status === ATTESTATION_STATUS.OUTDATED_PASSED || status === ATTESTATION_STATUS.ACTUAL_PASSED);

export const isUpcomming = (status: ATTESTATION_STATUS) => status === ATTESTATION_STATUS.UPCPMMING;